<template>
<span
    :class="state.color"
    class="flex p-2 items-center text-xs w-full font-medium uppercase">
    <template v-if="shipping">
                <TruckIcon class="h-5 w-5 mr-2"></TruckIcon> {{ state.name }}
    </template>

   <template v-if="!shipping">
                <BanknotesIcon class="h-5 w-5 mr-2"></BanknotesIcon> {{ state.name }}
    </template>

</span>

</template>

<script>
import {BanknotesIcon, TruckIcon} from "@heroicons/vue/24/outline";

export default {
    props: ['shipping', 'state'],
    components: {
        TruckIcon,
        BanknotesIcon
    }
}
</script>

<style scoped>

</style>
